var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 126,
    viewBox: "0 0 100 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4883_9662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 32.5643C100 32.5643 92.6994 91.0349 80.6938 104.194C66.2821 119.982 55.8256 117.675 50.0082 125.808C50 125.808 50 125.816 50 125.816C44.1826 117.666 33.7261 119.982 19.3062 104.186C7.29235 91.0349 0 32.5643 0 32.5643C31.6332 17.205 49.9918 0 49.9918 0C49.9918 0 49.9918 0 50 0.00823995C50.5686 0.543836 68.8612 17.4522 100 32.5643Z",
    fill: "#002060"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.0082 0.00823995V125.808C50 125.808 50 125.816 50 125.816C44.1826 117.666 33.7261 119.982 19.3062 104.186C7.29235 91.0349 0 32.5643 0 32.5643C31.6332 17.205 49.9918 0 49.9918 0C49.9918 0 49.9918 0 50.0082 0.00823995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M99.9996 32.5638C99.9996 32.5638 92.699 91.0345 80.6934 104.194C66.2817 119.981 55.8252 117.674 50.0078 125.807V0.0078125C50.5681 0.543409 68.8608 17.4518 99.9996 32.5638Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2381 37.2788C92.2381 37.2788 86.0664 86.6773 75.9312 97.793C63.7444 111.15 54.9111 109.181 49.9919 116.061C45.0726 109.181 36.2394 111.142 24.0525 97.793C13.9174 86.6691 7.75391 37.2788 7.75391 37.2788C34.4761 24.3009 49.9919 9.76562 49.9919 9.76562C49.9919 9.76562 65.5159 24.3009 92.2381 37.2788Z",
    fill: "#06C9F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.2972 10.0545V115.649C50.1901 115.781 50.0829 115.921 49.9841 116.053C45.0731 109.181 36.2316 111.142 24.0447 97.7852C13.9096 86.6612 7.74609 37.271 7.74609 37.271C34.4682 24.2931 49.9758 9.75781 49.9758 9.75781C49.9758 9.75781 50.0912 9.86493 50.2972 10.0545Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2023 60.8984H34.7969V84.6789H65.2023V60.8984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1618 56.1044H59.0718V53.2945C59.0718 48.2929 55.0013 44.2306 49.9996 44.2306C44.998 44.2306 40.9357 48.3011 40.9357 53.2945V65.6133H37.8457V53.2945C37.8457 46.5872 43.3005 41.1406 50.0079 41.1406C56.7152 41.1406 62.17 46.5955 62.17 53.2945V56.1044H62.1618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2845 71.2352L52.5534 77.275H47.1562L48.4252 71.2352C47.6671 70.7572 47.1562 69.9168 47.1562 68.9527C47.1562 67.4448 48.3675 66.25 49.859 66.25C51.3504 66.25 52.5617 67.4448 52.5617 68.9527C52.5534 69.9168 52.0425 70.749 51.2845 71.2352Z",
    fill: "#06C9F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4883_9662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 125.824,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityImg);
export default __webpack_public_path__ + "static/media/security-img.8fc027fc13e7ba4fb70fd2791eaa85a7.svg";
export { ForwardRef as ReactComponent };